import React, { useState, useEffect } from 'react';
import './TeamPublic.css';
import { useNavigate, useParams } from 'react-router-dom';
import api from '@api'; // Instead of ../../../utils/api
import { useDomain } from '@useDomain';
import BannerSlideshow from '../../Sponsors/SponsorSlideshow.jsx'
import BasketballTeamPublic from './BasketballTeamPublic.jsx';
import RacquetTeamPublic from './SportPages/Racquet/RacquetTeamPublic.jsx'

function TeamPublic() {
  const [team, setTeam] = useState(null);
  const { id } = useParams();
  const { domain, slug, organization } = useDomain();
  const [error, setError] = useState("");
  const [playersAttr, setPlayersAttr] = useState([])
  const [loading, setLoading] = useState(true); // 1. Add loading state
  const [teamBanners, setTeamBanners] = useState([]);
  const [bannerSettings, setBannerSettings] = useState({
    teams: { rotationSpeed: 5, animation:  "fade" }, // default
  });
  const [features, setFeatures] = useState([]);
  const navigate = useNavigate();
  const theme = organization?.theme_mode || "light";

  useEffect(() => {
    const getTeam = async () => {
      try {
        const response = await api.get(`/api/teamsv2/${id}`, {
          params: slug ? { slug } : { domain },
        });
        setTeam(response.data.team);
        const sourcePlayers =
          response.data.team.players?.length > 0
            ? response.data.team.players
            : (response.data.team.rosters || [])
              .map((r) => {
                if (!r.player) return null;

                return {
                  ...r.player,
                  roster_id: r.id,
                  seasons_leagues_teams_id: r.seasons_leagues_teams_id,
                  jersey_number: r.jersey_number,
                  position: r.position,
                };
              })
              .filter(Boolean);

        const uniquePlayersMap = new Map();

        sourcePlayers.forEach((player) => {
          const cleanedPlayer = {
            ...player,
            attributeValues: Array.from(
              new Map(
                player.attributeValues?.map((att) => [att.attribute_id, att]) || []
              ).values()
            ),
          };

          const existingPlayer = uniquePlayersMap.get(player.id);

          if (!existingPlayer) {
            uniquePlayersMap.set(player.id, cleanedPlayer);
          } else {
            uniquePlayersMap.set(player.id, {
              ...existingPlayer,
              jersey_number:
                existingPlayer.jersey_number || cleanedPlayer.jersey_number || null,
              position:
                existingPlayer.position || cleanedPlayer.position || null,
              roster_id:
                existingPlayer.roster_id || cleanedPlayer.roster_id,
            });
          }
        });

        setPlayersAttr(Array.from(uniquePlayersMap.values()));
      } catch (error) {
        console.error("Error fetching team:", error.response?.data || error.message);
        setError("Failed to fetch team");
      } finally {
        setLoading(false); // 2. Stop loading after fetch (success or fail)
      }
    };
    getTeam();
  }, [id, domain]);

  // const uniqueAttributes = Array.from(
  //   new Set(playersAttr.flatMap((player) =>
  //     player.attributeValues
  //       .filter(att => att.attribute.is_visible !== false)
  //       .map(att => att.attribute.attribute_name)
  //   ))
  // );


  useEffect(() => {
    if (!organization?.id) return;

    const load = async () => {
      try {
        // Load all banners
        const res = await api.get(
          `/api/organization-banner/organization/${organization.id}`
        );
        const banners = res.data.banners || [];

        // Filter ONLY team banners
        const filtered = banners.filter(
          (b) => b.placement === "teams" && b.enabled
        );
        setTeamBanners(filtered);

        // Load feature flags
        const featureRes = await api.get(
          `/api/organization-features/${organization.id}`
        );
        setFeatures(featureRes.data.features || []);
        // Load banner settings for TEAMS
        const settingsRes = await api.get(
          `/api/organization-features/${organization.id}/banner-settings/teams`
        );

        setBannerSettings(prev => ({
          ...prev,
          teams: settingsRes.data,
        }));


      } catch (err) {
        console.error("Error loading banners/features/settings:", err);
      }
    };

    load();
  }, [organization]);

  const allowTeamBanner = features.some(
    f => f.feature_key === "banner_team" && f.enabled
  );

  if (loading) return null;
  if (error) return <div>{error}</div>;

  const sportType = team?.sport?.type?.toLowerCase();

  const bannerSlot =
    allowTeamBanner && teamBanners.length > 0 ? (
      <BannerSlideshow
        banners={teamBanners}
        rotationSpeed={bannerSettings.teams.rotationSpeed}
        animation={bannerSettings.teams.animation}
      />
    ) : null;
  const sharedTeamProps = {
    team,
    playersAttr,
    slug,
    navigate,
    theme,
    bannerSlot,
  };

  if (
    sportType === "tennis" ||
    sportType === "pickleball" ||
    sportType === "racquetball"
  ) {
    return <RacquetTeamPublic {...sharedTeamProps} />;
  }

  return <BasketballTeamPublic {...sharedTeamProps} />;

}

export default TeamPublic;
